import Api from '../../api/Api'

const master = {
  //set namespace true
  namespaced: true,

  //state
  state: {
    topik: [],
    level: [],
    trainer: [],
    label: [],
    select_tags: {},
    select_level: {},
    select_trainer: {},
    select_label: {},
    info: [],
    select_info: [],
    batch: [],
    table_batch: [],
    edit_batch: {},
    slider: [],
    section_value: [],
    company: [],
    empty: '',
  },

  //mutations
  mutations: {
    SET_TOPIK(state, topik) {
      var temp = []
      topik.forEach((el) => {
        let data = {
          label: el.nama_kategori,
          value: el.id_kategori,
        }
        temp.push(data)
      })

      state.topik = topik
      state.select_tags = temp
    },
    SET_SLIDER(state, slider) {
      let a = []
      slider.forEach((el) => {
        let go = {
          link: el.link,
          name: el.sliders,
          id: el.id,
          status: el.status,
        }
        a.push(go)
      })
      state.slider = a
    },
    SET_COMPANY(state, company) {
      let a = []
      company.forEach((el) => {
        let go = {
          value: el.id,
          label: el.nama,
          photo: el.thumbnail,
          status: el.status,
        }
        a.push(go)
      })
      state.company = a
    },
    SET_SECTION_VALUE(state, section) {
      let a = []
      section.forEach((el) => {
        let go = {
          icon: el.icon,
          deskripsi: el.deskripsi,
          id: el.id,
          judul: el.judul,
          status: el.status,
        }
        a.push(go)
      })
      state.section_value = a
    },
    SET_LEVEL(state, level) {
      var temp = []
      level.forEach((el) => {
        let data = {
          label: el.nama_level,
          value: el.id_level,
        }
        temp.push(data)
      })

      state.level = level
      state.select_level = temp
    },
    SET_INFO(state, info) {
      var temp = []
      info.forEach((el) => {
        let data = {
          label: el.nama_info,
          value: el.id_info,
        }
        temp.push(data)
      })

      state.info = info
      state.select_info = temp
    },
    SET_TRAINER(state, trainer) {
      var temp = []
      trainer.forEach((el) => {
        let data = {
          label: el.nama,
          value: el.id_trainer,
          photo: el.url_foto,
          profesi: el.profesi,
        }
        temp.push(data)
      })

      state.trainer = trainer
      state.select_trainer = temp
    },
    SET_LABEL(state, label) {
      var temp = []
      label.forEach((el) => {
        let data = {
          label: el.nama_label,
          value: el.id_label,
        }
        temp.push(data)
      })

      state.label = label
      state.select_label = temp
    },
    SET_EDIT_BATCH(state, data) {
      state.edit_batch = data
    },
    SET_BATCH_WORKSHOP(state, batch) {
      var temp = []
      batch.forEach((el) => {
        let data = {
          batch: el.batch,
          tanggal: el.tanggal,
          waktu: el.waktu,
          lokasi: el.lokasi,
          harga: el.harga,
          harga_dilatih: el.harga_dilatih,
          harga_bnsp: el.harga_bnsp,
          trainer: el.nama_trainer,
          status: el.is_active,
          id: el.id,
        }
        temp.push(data)
      })
      console.log(temp)
      state.batch = batch
      state.table_batch = temp
    },
    SET_EMPTY(state, empty) {
      state.empty = empty
    },
  },

  //actions
  actions: {
    getProvinsi() {
      return new Promise((resolve, reject) => {
        const token = localStorage.getItem('token')
        Api.defaults.headers.common['Authorization'] = `Bearer ${token}`

        Api.get('/provinsi')
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    getRole() {
      return new Promise((resolve, reject) => {
        Api.get('/user/role')
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    bank() {
      return new Promise((resolve, reject) => {
        Api.get('/master/bank')
          .then((response) => {
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    cekPromo({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/cekPromo?kode=${data.kode}&event=${data.event}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    getEvent() {
      return new Promise((resolve, reject) => {
        Api.get('/user/event')
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    addon({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.get(`/master/addons?=page${param.page}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    faq() {
      return new Promise((resolve, reject) => {
        Api.get(`/faq`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    tambah_addons({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post(`/master/addons`, param)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    activated_company({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post(`/company/active`, param)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    addMateriEvent({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post(`/materi/addEvent`, param)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    statusslider({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post(`/slider/changestatusaktif`, param)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    statussection({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post(`/section_value/changestatusaktif`, param)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    cek_kelengkapan_profile() {
      return new Promise((resolve, reject) => {
        Api.get(`/cekKelengkapanProfile`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    updateMateriEvent({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post(`/materi/detail/${param.id}`, param)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    deleteMateriEvent({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post(`/materi/delete/${param.id}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    detailMateriEvent({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.get(`/materi/detail/${param.id}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    hapus_addons({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post(`/master/delete_addons/${param.id}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    landing_addon() {
      return new Promise((resolve, reject) => {
        Api.get(`/addons`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    getKota({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.get(`/kota?id_provinsi=${param.id_provinsi}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    Landing_Faq() {
      return new Promise((resolve, reject) => {
        Api.get(`/landing_faq`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    getPekerjaan() {
      return new Promise((resolve, reject) => {
        Api.get(`/get_pekerjaan`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    getInfo({ commit }) {
      return new Promise((resolve, reject) => {
        Api.get('/info')
          .then((response) => {
            commit('SET_INFO', response.data.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    LandingPromo() {
      return new Promise((resolve, reject) => {
        Api.get('/landing/promo')
          .then((response) => {
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    getKategori({ commit }) {
      return new Promise((resolve, reject) => {
        Api.get(`/kategori`)
          .then((response) => {
            commit('SET_TOPIK', response.data.data.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    getLabel({ commit }) {
      return new Promise((resolve, reject) => {
        Api.get(`/label`)
          .then((response) => {
            commit('SET_LABEL', response.data.data.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    getTrainer({ commit }) {
      return new Promise((resolve, reject) => {
        Api.get(`/landing_trainer`)
          .then((response) => {
            commit('SET_TRAINER', response.data.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    getMateri() {
      return new Promise((resolve, reject) => {
        Api.get(`/materi`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    trainer_preview({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/trainer_for_preview?data_pembicara=${data.trainer}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    getLevel({ commit }) {
      return new Promise((resolve, reject) => {
        Api.get(`/level`)
          .then((response) => {
            commit('SET_LEVEL', response.data.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    edit_level({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/level/detail_level/${data.id_level}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    edit_batch({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/workshop/detailbatch/${data.id}/${data.id_batch}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    edit_materi({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/materi/detail/${data.id}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    edit_kategori({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/kategori/detail_kategori/${data.id_kategori}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    edit_label({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/label/detail_label/${data.id_label}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    edit_trainer({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/trainer/detail_trainer/${data.id_trainer}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    edit_faq({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/faq/detail/${data.id_faq}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    getLanding() {
      return new Promise((resolve, reject) => {
        Api.get(`/landing_insight`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    update_level({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/level/update_level/${data.id_level}`, {
          nama_level: data.nama_level,
        })
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    updateMateri({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/materi/detail/${data.id}`, data)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    update_landing({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/landing/update`, data)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    update_faq({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/faq/update`, {
          id_faq: data.id_faq,
          answer: data.answer,
          question: data.question,
        })
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    update_pembicara({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/trainer/update_trainer`, data)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    aktif_pembicara({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/trainer/update_active_trainer`, data)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    detailPembicara({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/trainer/detail_trainer/${data.id_trainer}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    getBatch({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/batch/byedit/${data.id}`)
          .then((response) => {
            commit('SET_BATCH_WORKSHOP', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    Batch({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/workshop/batch?id=${data.id}&id_batch=${data.id_batch}&page=${data.page}&per_page=${data.per_page}&status=${data.status}&search=${data.search}&topik=${data.topik}&tanggal_mulai=${data.tanggal_mulai}&tanggal_selesai=${data.tanggal_selesai}`,
        )
          .then((response) => {
            commit('SET_BATCH_WORKSHOP', response.data.data.data)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    detailBatch({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/batch/detail/${data.id}`)
          .then((response) => {
            commit('SET_EDIT_BATCH', response.data.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    detail_section({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`/section_value/detail/${data.id}`)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    getSection({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/section_value?page=${data.page}&per_page=${data.per_page}&search=${data.search}&status=${data.status}`,
        )
          .then((response) => {
            commit('SET_SECTION_VALUE', response.data.data.data)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    add_section({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/section_value`, data)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    kirimPengajuanWorkshop({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/interested`, data)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    trainerAktif() {
      return new Promise((resolve, reject) => {
        Api.get(`/trainer/active`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    trainerAktifLanding() {
      return new Promise((resolve, reject) => {
        Api.get(`/trainer/active/landing`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    kenapa_dilatih() {
      return new Promise((resolve, reject) => {
        Api.get(`/kenapa_dilatih`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    update_label({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/label/update_label/${data.id_label}`, {
          nama_label: data.nama_label,
        })
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    update_section({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/section_value/update/${data.id}`, data)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    update_kategori({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post(`/kategori/update_kategori/${data.id_kategori}`, {
          nama_kategori: data.nama_kategori,
        })
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    getLandingLevel() {
      return new Promise((resolve, reject) => {
        Api.get(`/landing_level`)
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error.response)
          })
      })
    },
    addKategori({ commit }, kategori) {
      return new Promise((resolve, reject) => {
        Api.post('kategori', kategori)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    addBatch({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post('batch', param)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updateBatch({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post('batch/updatebatch', param)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    add_slider({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post('slider', param)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    sliderLanding({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.get('sliderLanding', param)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    add_product({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post('product', param)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    updateslider({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post('slider/update', param)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    get_slider({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(
          `slider?page=${data.page}&per_page=${data.per_page}&search=${data.search}&is_active=${data.is_active}`,
        )
          .then((response) => {
            commit('SET_SLIDER', response.data.data.data)
            resolve(response.data.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    company({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.get(`company`)
          .then((response) => {
            commit('SET_COMPANY', response.data.data)
            resolve(response.data)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    get_product() {
      return new Promise((resolve, reject) => {
        Api.get('product')
          .then((response) => {
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    delete_slider({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post('slider/delete/' + param.id)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    delete_product({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post('product/delete/' + param.id)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    addLabel({ commit }, label) {
      return new Promise((resolve, reject) => {
        Api.post('label', label)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    addTrainer({ commit }, trainer) {
      return new Promise((resolve, reject) => {
        Api.post('trainer', trainer)
          .then((response) => {
            commit('SET_EMPTY')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    tambah_faq({ commit }, trainer) {
      return new Promise((resolve, reject) => {
        Api.post('faq', trainer)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    tambah_faq_workshop({ commit }, trainer) {
      return new Promise((resolve, reject) => {
        Api.post('faq/add_faq_workshop', trainer)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deleteLabel({ commit }, label) {
      return new Promise((resolve, reject) => {
        Api.post('label/delete/' + label.id_label)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    addMateri({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post('materi', param)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deleteBatch({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post('batch/delete/' + param.id)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    activeBatch({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post('batch/activeBatch/' + param.id)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deactiveBatch({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.post('batch/deactiveBatch/' + param.id)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    hapus_faq({ commit }, label) {
      return new Promise((resolve, reject) => {
        Api.post('faq/delete/' + label.id)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    hapus_materi({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post('materi/delete/' + data.id)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deletePembicara({ commit }, label) {
      return new Promise((resolve, reject) => {
        Api.post('trainer/delete/' + label.id_label)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    deleteKategori({ commit }, label) {
      return new Promise((resolve, reject) => {
        Api.post('kategori/delete/' + label.id_tags)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    delete_section({ commit }, data) {
      return new Promise((resolve, reject) => {
        Api.post('section_value/delete/' + data.id)
          .then((response) => {
            commit('SET_EMPTY', '')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },

  //getters
  getters: {
    getTopik(state) {
      return state.topik
    },
    getSelectTopik(state) {
      return state.select_tags
    },
    getLevel(state) {
      return state.level
    },
    getSelectLevel(state) {
      return state.select_level
    },
    getTrainer(state) {
      return state.trainer
    },
    getSelectTrainer(state) {
      return state.select_trainer
    },
    getLabel(state) {
      return state.trainer
    },
    getSelectLabel(state) {
      return state.select_label
    },
    getInfo(state) {
      return state.info
    },
    getSelectInfo(state) {
      return state.select_info
    },
    getTableBatch(state) {
      return state.table_batch
    },
    getEditBatch(state) {
      return state.edit_batch
    },
    getSlider(state) {
      return state.slider
    },
    getSectionValue(state) {
      return state.section_value
    },
    getCompany(state) {
      return state.company
    },
  },
}

export default master
